import { useQuery } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { usersApi } from '../services/usersApi';
import { formErrorMessageForToast } from '../utils/backEndErrorMessages';

export const useQualityUsers = () => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const { t } = useTranslation();

  return useQuery(['template-owner-quality-users', companyId], () => usersApi.fetchUsers(companyId), {
    onError: (error) => {
      showToast({
        title: t('common.toast.error'),
        description: formErrorMessageForToast(t('template.hooks.fetchUsers.error'), error),
        status: 'error',
        'data-cy': 'toast-fetch-users-error',
      });
    },
  });
};
